/**
 * Add to cart price: swaps the add to cart label to the selected selling plan price.
 * Subscription apps (Recharge) set the form's hidden "selling_plan" input without firing a change event,
 * so the form is watched for value attribute mutations as well.
 */
(() => {
  class AddToCartPrice extends HTMLElement {
    connectedCallback() {
      this.form = document.forms[this.getAttribute('form-id')];
      this.labels = JSON.parse(this.querySelector('script[data-add-to-cart-labels]')?.textContent || '{}');

      if (!this.form) return;

      this.update = this.update.bind(this);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
      this.form.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.form?.removeEventListener('change', this.update);
    }

    update() {
      const sellingPlanId = new FormData(this.form).get('selling_plan') || '';
      const label = this.labels[sellingPlanId] ?? this.labels[''];

      if (!label) return;

      this.querySelectorAll('button-content').forEach((content) => {
        if (content.textContent.trim() === label) return;

        content.textContent = label;

        ['up-text', 'rotated-text'].forEach((attribute) => {
          if (content.hasAttribute(attribute)) content.setAttribute(attribute, label);
        });
      });
    }
  }

  if (!window.customElements.get('add-to-cart-price')) {
    window.customElements.define('add-to-cart-price', AddToCartPrice);
  }
})();
